import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { Job } from 'src/app/shared/models/focusDataModels/Job';
import { LaborShift } from 'src/app/shared/models/laborScheduling/LaborShift.model';

@Component({
	selector: 'app-employee-labor-shift-record',
	templateUrl: './employee-labor-shift-record.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class EmployeeLaborShiftRecordComponent implements OnInit {
	@Input() laborShift: LaborShift;
	@Output() laborShiftChange = new EventEmitter<LaborShift>();
	changesToSave: boolean = false;

	endTimeAlert: string;

	jobList: Job[];

	newRecord: boolean = false;

	shiftMinutes: number = 0;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		!this.laborShift.shiftKey && (this.newRecord = true);
		this.jobList = this.venueService.jobList.value;
		this.app.loading(false);
		this.shiftTimeChange();
	}

	back() {
		this.laborShiftChange.emit(undefined);
		this.laborShift = undefined;
	}

	async delete() {
		const resp = await this.focuslink.laborShiftDelete(this.venueService.subscriptionVenue.value.key, this.laborShift.shiftKey);
		const existingIdx = this.venueService.laborShiftList.value.findIndex((i) => i.shiftKey === this.laborShift.shiftKey);
		this.venueService.laborShiftList.value.splice(existingIdx, 1);
		this.venueService.laborShiftList.next(this.venueService.laborShiftList.value);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Shift deleted.` });
		this.back();
	}

	async save() {
		this.laborShift.shiftKey = this.app.uuidv4();
		const shiftToSave = this.app.clone(this.laborShift);
		delete shiftToSave.job;
		delete shiftToSave.jobName;

		const resp = await this.focuslink.laborShiftSave(this.venueService.subscriptionVenue.value.key, shiftToSave);
		if (this.newRecord) {
			this.venueService.laborShiftList.value.push(this.laborShift);
		} else {
			const existingIdx = this.venueService.laborShiftList.value.findIndex((i) => i.shiftKey === this.laborShift.shiftKey);
			this.venueService.laborShiftList[existingIdx] = this.laborShift;
		}
		this.venueService.laborShiftList.next(this.venueService.laborShiftList.value);

		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Shift saved successfully.` });
		this.changesToSave = false;
	}

	setShiftJob(event) {
		console.log(event);
	}

	shiftTimeChange() {
		this.shiftMinutes = this.app.moment(this.laborShift.endTime, 'HH:mm').diff(this.app.moment(this.laborShift.startTime, 'HH:mm'), 'minute');

		if (
			this.laborShift.startTime &&
			this.laborShift.endTime &&
			this.app.moment(this.laborShift.startTime, 'HH:mm').isSameOrAfter(this.app.moment(this.laborShift.endTime, 'HH:mm'))
		) {
			this.endTimeAlert = `Shift end time must be greater than shift end time.`;
		} else {
			this.endTimeAlert = undefined;
		}
	}

	validateDelete(): boolean {
		if (!this.laborShift.shiftKey) {
			return true;
		}

		return false;
	}

	validateSave(): boolean {
		if (
			!this.laborShift.startTime ||
			!this.laborShift.endTime ||
			!this.laborShift.name ||
			!this.laborShift.jobId ||
			!this.changesToSave ||
			this.app.moment(this.laborShift.startTime, 'HH:mm').isSameOrAfter(this.app.moment(this.laborShift.endTime, 'HH:mm'))
		) {
			return true;
		}
		return false;
	}
}
